import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import withDataConsumer from '../../api/contextApi/withDataConsumer';

class LogOut extends Component {
  render() {
    this.props.context.logOut();
    return (
      <Redirect to="/" />
    );
  }
}

export default withDataConsumer(LogOut);



// WEBPACK FOOTER //
// ./src/components/Admin/LogOut.js